var React = require('react');

function Fb (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillOpacity":".5","fillRule":"evenodd","d":"M8.04 5.453l-.296 2.752H5.505v7.982H2.14V8.205H.463V5.453H2.14V3.795c0-2.236.947-3.573 3.641-3.573h2.238v2.751H6.62c-1.047 0-1.115.388-1.115 1.106v1.374H8.04z"}));
}

Fb.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17"};

module.exports = Fb;

Fb.default = Fb;
